module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Transmitter Group")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Transmitter Group")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Transmitters")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.transmitters,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.transmitters),
      callback: function($$v) {
        _vm.form.transmitters = $$v
      },
      expression: "form.transmitters"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/transmitters/groups"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Transmitter Groups")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('p', [_vm._v("A transmitter group combines one of several transmitters to a logical entity. The group all contains all registered transmitters. Other groups are assigned by their coverage area.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78cf9d6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transmitter/group/New.vue
// module id = 627
// module chunks = 1